import { Stack, styled } from '@mui/material'
import { createAccountPresentation, TaskStatusLabel, tokens, type User, UserBubbleList } from 'ComponentLibrary'
import { ClipboardTextIcon } from '@phosphor-icons/react'
import { Task } from 'ComponentLibrary/src/common/tasks'
import { TextWithEllipsis } from 'ComponentLibrary/src/piazza/text'
import { type UserLinkCopy } from 'ComponentLibrary/src/piazza/text/UserLink/UserLink'

type TaskListItemProps = {
    task: Task
    users?: User[]
    onClick: (task: Task) => void
    userLinkCopy?: Partial<UserLinkCopy>
    statusLabels?: Partial<Record<Task['status'], string>>
}

export const TaskListPreviewItem = ({ task, users, onClick, userLinkCopy, statusLabels }: TaskListItemProps) => {
    const assignee = users?.find((user) => user.id === task.assignee?.id)

    return (
        <StyledStack direction="row" gap={tokens.SizingSpacing300} onClick={() => onClick(task)} alignItems="center">
            <Stack direction="row" gap={tokens.SizingSpacing150} alignItems="center" flex={1} minWidth={0}>
                <ClipboardTextIcon color={tokens.ColorIconBoldest} size={tokens.SizingIconM} style={{ flexShrink: 0 }} />
                <Stack direction="column" width="100%" minWidth={0}>
                    <TextWithEllipsis
                        tooltipText={task.title}
                        typographyProps={{ variant: 'textS', color: tokens.ColorIconLinkDefault }}
                        fullWidth
                    >
                        {task.title}
                    </TextWithEllipsis>
                    {task.description && (
                        <TextWithEllipsis
                            tooltipText={task.description}
                            typographyProps={{ variant: 'textS', color: tokens.ColorTextDefault }}
                            fullWidth
                        >
                            {task.description}
                        </TextWithEllipsis>
                    )}
                </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" gap={tokens.SizingSpacing300} flexShrink={0}>
                <TaskStatusLabel status={task.status} size="18px" label={statusLabels?.[task.status]} />
                <UserBubbleList presentations={assignee ? [createAccountPresentation(assignee)] : []} userLinkCopy={userLinkCopy} />
            </Stack>
        </StyledStack>
    )
}

const StyledStack = styled(Stack)(() => ({
    padding: '8px 16px',
    cursor: 'pointer',
    justifyContent: 'space-between',
    minHeight: '55px',
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: tokens.ColorSurfaceDisabled,
    },
}))
